import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { SmallProjectCard } from './SmallProjectCard.js';
import { LoadingEllipsis } from './LoadingEllipsis.js';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';

/* global Uri */ // Defined in general.js

const LoadingCard = () => {
    return <div className="col col4"><div className="project-loading" /></div>;
};

const LoadingSection = () => {
    return (
        <div className="fluid-container project-loading-holder">
            <LoadingEllipsis />
            <LoadingCard/>
            <LoadingCard/>
            <LoadingCard/>
        </div>
    );
};

const LoadingFailedSection = () => {
    return (
        <div className="fluid-container project-loading-holder">
            <div className="no-projects">Aw shucks, we can&rsquo;t load any projects right now. Please try again in a bit.</div>
            <LoadingCard/>
            <LoadingCard/>
            <LoadingCard/>
        </div>
    );
};

export const HomeProjectSection = createReactClass({
    propTypes: {
        searchURL: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        seeMoreText: PropTypes.string,
        hideSeeMore: PropTypes.bool,
        loadProjects: PropTypes.func,
        detectedLocation: PropTypes.object,
        className: PropTypes.string.isRequired,
        projects: PropTypes.arrayOf(PropTypes.object),
        showGiveWidget: PropTypes.bool,
        prepopulatedDonationAmountForGiveWidget: PropTypes.number,
        giveWidgetSubmitTakesUserDirectlyToCart: PropTypes.bool,
        projectToAmountGivenMap: PropTypes.array,
        onProjectCardClick: PropTypes.func,
        altViewForFullyFundedProjects: PropTypes.bool,
    },

    mixins: [
        PureRenderMixin,
    ],

    componentDidMount: function () {
        const props = this.props;
        if (props.loadProjects && props.searchURL) {
            props.loadProjects(props.searchURL);
        }
    },

    // For A/B test
    UNSAFE_componentWillReceiveProps: function (nextProps) {
        const props = this.props;
        // TODO:  what is this for?
        // eslint-disable-next-line react/prop-types
        if (props.alternateHomeSection !== nextProps.alternateHomeSection) {
            if (nextProps.loadProjects && nextProps.searchURL) {
                nextProps.loadProjects(nextProps.searchURL);
            }
        }
    },

    getTitle: function () {
        const props = this.props;
        if (!props.title) {
            return null;
        }
        return (<h2><a href={this.getSearchURL()}>{props.title}</a></h2>);
    },

    getDescription: function () {
        const props = this.props;
        if (!props.description) {
            return null;
        }
        return (<h4>{props.description.toUpperCase()}</h4>);
    },

    getSeeMore: function () {
        const props = this.props;
        if (props.hideSeeMore) {
            return null;
        }
        const url = this.getSearchURL();
        return (<a href={url} className="button-secondary view-all">{this.getSeeMoreText()}</a>);
    },

    getSeeMoreText: function () {
        const props = this.props;
        if (props.seeMoreText) {
            return props.seeMoreText;
        }
        return 'See all ' + props.title.toLowerCase();
    },

    getSearchURL: function () {
        // Links to search should only load the normal 10 projects and not filter out photo-less projects
        return new Uri(this.props.searchURL).deleteQueryParam('max').deleteQueryParam('hasPhoto').toString();
    },

    getOffsetClassnameForProjectCard: function (index, numProjects) {
        if (index !== 0) {
            return '';
        }
        if (numProjects === 2) {
            return 'col-offset2';
        }
        if (numProjects === 1) {
            return 'col-offset4';
        }
    },

    render: function () {
        const props = this.props;
        let projectList;

        if (!props.projects) {
            projectList = <LoadingSection/>;
        } else if (props.projects.length === 0) {
            projectList = <LoadingFailedSection/>;
        } else {
            projectList = props.projects.map(
                (project, index) => {
                    // These projectIds are different types
                    const projectList = props.projectToAmountGivenMap && props.projectToAmountGivenMap.length > 0 ? props.projectToAmountGivenMap.filter(d => parseInt(d.projectId) === parseInt(project.id)) : null;
                    const amountGiven = projectList && projectList.length > 0 ? projectList[0].amountGiven : undefined;
                    return <SmallProjectCard
                        project={project}
                        key={project.id}
                        showGiveWidget={props.showGiveWidget}
                        prepopulatedDonationAmountForGiveWidget={props.prepopulatedDonationAmountForGiveWidget}
                        giveWidgetSubmitTakesUserDirectlyToCart={props.giveWidgetSubmitTakesUserDirectlyToCart}
                        amountGiven={amountGiven}
                        description={this.getDescription()}
                        className={this.getOffsetClassnameForProjectCard(index, props.projects.length)}
                        onProjectCardClick={props.onProjectCardClick}
                        altViewForFullyFundedProjects={props.altViewForFullyFundedProjects}
                    />;
                },
            );
        }

        return (
            <section className={'projects ' + props.className}>
                <div className="container">
                    {this.getTitle()}
                    {this.getDescription()}
                    <div className="fluid-container">
                        {projectList}
                    </div>
                    {this.getSeeMore()}
                </div>
            </section>
        );
    },
});
